import React, { useState } from "react";
import { Grid, Paper } from "@mui/material/";
import AutoComp from "./AutoComp";

export default function GridAutoComplete(props) {
  const MeasureData = props.MeasureData;
  const country = props.selectedCountry;

  // Fill this array with the columns you want the present or use in the components from here
  const columnTableRequested = [
    "measure_number",
    "pub_year",
    "measure_category",
    "measure_name",
    "country",
    "measure_subcategory",
    "measure_type",
  ];

  // The list is the Autocomplete list that is used to be filled in the Autcomplete
  let listCategory = [];
  let listSubCategory = [];
  let listMeasure = [];
  let listTitle = [];
  // To store the chosen value of the Autocomplete
  const [chosenCategory, setChosenCategory] = useState(null);
  const [chosenSubCategory, setChosenSubCategory] = useState(null);
  const [chosenMeasure, setChosenMeasure] = useState(null);

  // Update lists per autocomplete. Per selection it will be determined if there is an other selection made that is bound to the other autocomplete (e.g.: A Specific Measure, connected to a sub and category)
  const UpdateLists = (data) => {
    data.map((element) => {
      if (
        !listCategory.includes(element[columnTableRequested[2]]) &&
        element[columnTableRequested[2]] !== null &&
        (chosenSubCategory === element[columnTableRequested[5]] ||
          chosenSubCategory === null) &&
        (chosenMeasure === element[columnTableRequested[6]] ||
          chosenMeasure === null) &&
        (String(element[columnTableRequested[4]]).includes(country) ||
          country === "none" ||
          String(element[columnTableRequested[4]]) === "European Union")
      ) {
        listCategory.push(element[columnTableRequested[2]]);
      }
      if (
        !listSubCategory.includes(element[columnTableRequested[5]]) &&
        element[columnTableRequested[5]] !== null &&
        (chosenCategory === element[columnTableRequested[2]] ||
          chosenCategory === null) &&
        (chosenMeasure === element[columnTableRequested[6]] ||
          chosenMeasure === null) &&
        (String(element[columnTableRequested[4]]).includes(country) ||
          country === "none" ||
          String(element[columnTableRequested[4]]) === "European Union")
      ) {
        listSubCategory.push(element[columnTableRequested[5]]);
      }
      if (
        !listMeasure.includes(element[columnTableRequested[6]]) &&
        element[columnTableRequested[6]] !== null &&
        (chosenCategory === element[columnTableRequested[2]] ||
          chosenCategory === null) &&
        (chosenSubCategory === element[columnTableRequested[5]] ||
          chosenSubCategory === null) &&
        (String(element[columnTableRequested[4]]).includes(country) ||
          country === "none" ||
          String(element[columnTableRequested[4]]) === "European Union")
      ) {
        listMeasure.push(element[columnTableRequested[6]]);
      }
      if (
        !listTitle.includes(element[columnTableRequested[3]]) &&
        element[columnTableRequested[3]] !== null &&
        (String(element[columnTableRequested[4]]).includes(country) ||
          country === "none" ||
          String(element[columnTableRequested[4]]) === "European Union")
      ) {
        listTitle.push(element[columnTableRequested[3]]);
      }
    });
  };

  // Update the Category state when Autocomplete spits out a value
  const updateCategory = (data) => {
    setChosenCategory(data);
    props.selectedCat(data);
    updateData();
  };

  // Update the Subcategory state when Autocomplete spits out a value
  const updateSubCategory = (data) => {
    setChosenSubCategory(data);
    props.selectedSubCat(data);
    updateData();
  };

  // Update the Specific measure state when Autocomplete spits out a value
  const updateMeasure = (data) => {
    setChosenMeasure(data);
    props.selectedMeas(data);
    updateData();
  };

  // Update the Publication Title state when Autocomplete spits out a value
  const updateTitle = (data) => {
    props.selectedTitle(data);
    updateData();
  };

  // Function to update all the lists of the Autocomplete
  const updateData = () => {
    listCategory = [];
    listSubCategory = [];
    listMeasure = [];
    listTitle = [];
    UpdateLists(MeasureData);
  };

  // Just wait for FetchRequest to be completed, then do the job
  if (MeasureData !== null) {
    UpdateLists(MeasureData);
  }

  return (
    <Grid container justifyContent="space-between" gap={8}>
      <Grid
        component={Paper}
        container
        item
        direction="row"
        justifyContent="space-around"
        minWidth={350}
        lg={8}
        xs={12}
        padding={2}
        paddingTop={0}
      >
        <Grid item>
          <AutoComp
            label={"Category of measure"}
            options={listCategory}
            selection={updateCategory}
          />
        </Grid>
        <Grid item>
          <AutoComp
            label={"Subcategory of measure"}
            options={listSubCategory}
            selection={updateSubCategory}
          />
        </Grid>
        <Grid item>
          <AutoComp
            label={"Type of measure"}
            options={listMeasure}
            selection={updateMeasure}
          />
        </Grid>
      </Grid>

      <Grid
        component={Paper}
        container
        item
        direction="row"
        justifyContent="center"
        minWidth={350}
        lg={3}
        xs={12}
        padding={2}
        paddingTop={0}
      >
        <Grid item>
          <AutoComp
            label={"Search for measure"}
            options={listTitle}
            selection={updateTitle}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
